var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-item',{attrs:{"author":_vm.feedback.author,"created-at":_vm.feedback.created_at,"icon-name":"merge-request"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.eventText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }